<template>
  <div>
    <Input
      @on-focus="openUser = true"
      :value="name"
      readonly
      placeholder="请选择"
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openUser"
      draggable
      class="my-drawer"
    >
      <userTree @user="reUser"></userTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name","placement"],
  data() {
    return {
      openUser: false,
    };
  },
  methods: {
    reUser(v) {
      this.openUser = false;
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.name);
      this.$emit("user", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectUser.vue